<template>
  <div class="clients">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid waajo-account-page">
          <div class="waajo-account-heading">
            <div class="waajo-account-heading-copy">
              <h3>Lisensi WhatsApp</h3>
              <p>Kelola nomor WhatsApp, status koneksi, dan masa aktif lisensi Anda.</p>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/index">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Lisensi WhatsApp</li>
              </ul>
            </div>
            <!-- <router-link to="/subscriptions" class="btn waajo-btn-primary">
              <i class="fa fa-plus" aria-hidden="true"></i>
              Beli Lisensi
            </router-link> -->
          </div>

          <div class="waajo-account-layout">
            <div class="waajo-account-main">
              <div class="waajo-stat-grid">
                <div class="waajo-stat-card">
                  <span class="waajo-stat-icon is-wa"><i class="fa fa-whatsapp"></i></span>
                  <div class="waajo-stat-copy">
                    <span class="waajo-stat-label">Total Nomor</span>
                    <strong>{{ summaryTotal === null ? "—" : summaryTotal }}</strong>
                    <small>nomor WhatsApp terdaftar</small>
                  </div>
                </div>
                <div class="waajo-stat-card">
                  <span class="waajo-stat-icon is-online"><i class="fa fa-signal"></i></span>
                  <div class="waajo-stat-copy">
                    <span class="waajo-stat-label">Aktif / Online</span>
                    <strong>{{ statusMetrics.online === null ? "—" : statusMetrics.online }}</strong>
                    <small>nomor terhubung</small>
                  </div>
                </div>
                <div class="waajo-stat-card">
                  <span class="waajo-stat-icon is-alert"><i class="fa fa-exclamation-triangle"></i></span>
                  <div class="waajo-stat-copy">
                    <span class="waajo-stat-label">Perlu Scan QR</span>
                    <strong>{{ statusMetrics.scan === null ? "—" : statusMetrics.scan }}</strong>
                    <small>nomor perlu autentikasi</small>
                  </div>
                </div>
                <div class="waajo-stat-card">
                  <span class="waajo-stat-icon is-license"><i class="fa fa-calendar-check-o"></i></span>
                  <div class="waajo-stat-copy">
                    <span class="waajo-stat-label">Lisensi Aktif</span>
                    <strong>{{ statusMetrics.active === null ? "—" : statusMetrics.active }}</strong>
                    <small>dari total lisensi</small>
                  </div>
                </div>
              </div>

              <div v-if="metricsLoading" class="waajo-inline-note">
                <i class="fa fa-spinner fa-spin"></i> Memuat ringkasan status nomor...
              </div>
              <div v-else-if="metricsError" class="waajo-inline-error">
                <span><i class="fa fa-exclamation-circle"></i> {{ metricsError }}</span>
                <button type="button" class="waajo-link-btn" @click="loadSummary">Coba lagi</button>
              </div>
              <div v-else-if="!metricsComplete" class="waajo-inline-note">
                <span><i class="fa fa-info-circle"></i> Ringkasan status belum lengkap karena jumlah nomor melebihi batas data yang dapat dimuat.</span>
                <button type="button" class="waajo-link-btn" @click="loadMetrics">Muat ulang</button>
              </div>

              <section class="waajo-panel waajo-numbers-panel">
                <div class="waajo-panel-head waajo-numbers-head">
                  <div>
                    <h4>Daftar Nomor WhatsApp</h4>
                    <p>Kelola nomor WhatsApp yang terhubung dengan lisensi Anda.</p>
                  </div>
                  <div class="waajo-number-tools">
                    <div class="waajo-search-box">
                      <i class="fa fa-search"></i>
                      <input
                        v-model="searchText"
                        type="text"
                        placeholder="Cari nomor atau label..."
                        @keyup.enter="applySearch"
                      />
                    </div>
                    <select v-model="serverParams.license_status" class="waajo-select" @change="searchData">
                      <option value="">Semua Status</option>
                      <option value="active">Active</option>
                      <option value="almost_expired">Almost Expired</option>
                      <option value="expired">Expired</option>
                      <option value="draft">Draft</option>
                    </select>
                    <button type="button" class="btn waajo-btn-secondary waajo-icon-btn" title="Cari" @click="applySearch">
                      <i class="fa fa-search"></i>
                    </button>
                    <!-- <button type="button" class="btn waajo-btn-primary" @click="openAddNumber">
                      <i class="fa fa-plus"></i> Tambah Nomor
                    </button> -->
                    <RouterLink :to="'/subscriptions'" class="btn waajo-btn-primary">
                       <i class="fa fa-plus"></i> Tambah Nomor
                    </RouterLink>
                  </div>
                </div>

                <div v-if="listError" class="waajo-inline-error">
                  <span><i class="fa fa-exclamation-circle"></i> {{ listError }}</span>
                  <button type="button" class="waajo-link-btn" @click="loadItems">Coba lagi</button>
                </div>

                <div class="table-responsive waajo-number-table-wrap">
                  <table class="table waajo-number-table mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nomor WhatsApp</th>
                        <th>Label</th>
                        <th>Status</th>
                        <!-- <th>Lisensi</th> -->
                        <th>Masa Aktif</th>
                        <th class="text-right">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td colspan="6"><Skeleton :count="2" /></td>
                      </tr>
                      <tr v-else-if="rows.length === 0 && !listError">
                        <td colspan="6">
                          <div class="waajo-table-empty">
                            <i class="fa fa-whatsapp"></i>
                            <strong>Belum ada nomor WhatsApp</strong>
                            <span>Tambahkan nomor untuk mulai menghubungkan WhatsApp.</span>
                            <!-- <button type="button" class="btn waajo-btn-primary" @click="openAddNumber">
                              <i class="fa fa-plus"></i> Tambah Nomor
                            </button> -->
                            <RouterLink :to="'/subscriptions'" class="btn waajo-btn-primary">
                              <i class="fa fa-plus"></i> Tambah Nomor
                            </RouterLink>
                          </div>
                        </td>
                      </tr>
                      <template v-else>
                        <tr v-for="(row, index) in rows" :key="row.id || index">
                          <td class="waajo-row-number">{{ (currentPage - 1) * serverParams.perPage + index + 1 }}</td>
                          <td>
                            <div class="waajo-wa-number">
                              <i class="fa fa-whatsapp"></i>
                              <span>{{ displayPhone(row) }}</span>
                            </div>
                            <small v-if="!isPhoneNumber(row.license_phone_number)" class="waajo-muted-text">
                              Nomor belum diatur
                            </small>
                          </td>
                          <td>
                            <div class="waajo-license-name">{{ row.license_name || "-" }}</div>
                            <small v-if="licenseCreatedDate(row)" class="waajo-muted-text">
                              Ditambahkan {{ licenseCreatedDate(row) }}
                            </small>
                          </td>
                          <td>
                            <span class="waajo-status-pill" :class="statusClass(row)">
                              <i :class="statusIcon(row)"></i>
                              {{ statusLabel(row) }}
                            </span>
                            <small
                              v-if="connectionState(row) === 'offline' && !isLicenseExpired(row)"
                              class="waajo-muted-text"
                            >
                              Perlu scan untuk menautkan
                            </small>
                            <small
                              v-else-if="connectionState(row) === 'unconfigured'"
                              class="waajo-muted-text"
                            >
                              Nomor WhatsApp belum valid
                            </small>
                          </td>
                          <!-- <td>{{ licenseProductLabel(row) }}</td> -->
                          <td>
                            <div class="waajo-license-expiry">
                              <span>{{ licenseExpiryDate(row) }}</span>
                              <small v-if="licenseExpiryRemaining(row)">{{ licenseExpiryRemaining(row) }}</small>
                              <small v-else-if="licenseExpiryStatus(row)" :class="licenseExpiryStatusClass(row)">
                                {{ licenseExpiryStatus(row) }}
                              </small>
                            </div>
                          </td>
                          <td class="text-right">
                            <div class="waajo-row-actions">
                              <router-link
                                :to="'/license/info?id=' + row.id"
                                class="btn waajo-row-detail waajo-btn-primary"
                                :title="'Lihat detail ' + (displayPhone(row) || 'lisensi')"
                                :aria-label="'Lihat detail ' + (displayPhone(row) || 'lisensi')"
                              >
                                <i class="fa fa-eye"></i>
                                <span class="waajo-action-label">Detail</span>
                              </router-link>
                              <div class="dropdown waajo-row-options">
                                <button
                                  type="button"
                                  class="btn waajo-btn-secondary waajo-row-more dropdown-toggle"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  title="Aksi lainnya"
                                  aria-label="Aksi lainnya"
                                >
                                  <i class="fa fa-ellipsis-h"></i>
                                  <span>Lainnya</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <router-link
                                    v-if="connectionState(row) === 'unconfigured'"
                                    :to="'/license/info?id=' + row.id + '&edit=1'"
                                    class="dropdown-item"
                                  >
                                    <i class="fa fa-pencil text-warning"></i> Perbaiki Nomor
                                  </router-link>
                                  <button
                                    type="button"
                                    class="dropdown-item"
                                    @click="goRenewal(row)"
                                  >
                                    <i class="fa fa-shopping-cart text-info"></i> Perpanjang Lisensi
                                  </button>
                                  <button
                                    v-if="connectionState(row) === 'offline' && isPhoneNumber(row.license_phone_number) && !isLicenseExpired(row)"
                                    type="button"
                                    class="dropdown-item"
                                    @click="goScanQr(row)"
                                  >
                                    <i class="fa fa-qrcode text-warning"></i> Scan QR Code
                                  </button>
                                  <button
                                    v-if="connectionState(row) === 'unknown' && isPhoneNumber(row.license_phone_number)"
                                    type="button"
                                    class="dropdown-item"
                                    @click="refreshRowStatus(row)"
                                  >
                                    <i class="fa fa-refresh"></i> Cek Status
                                  </button>
                                  <button v-if="Number(row.is_chat) === 1" type="button" class="dropdown-item" @click="goChatRoom(row)">
                                    <i class="fa fa-comments-o text-success"></i> Buka Chat Room
                                  </button>
                                  <button type="button" class="dropdown-item" @click="goApiInfo(row)">
                                    <i class="fa fa-user"></i> API Key &amp; Others
                                  </button>
                                  <button type="button" class="dropdown-item" @click="toggleChatRoom(row)">
                                    <i :class="formInput[row.id] ? 'fa fa-toggle-on text-success' : 'fa fa-toggle-off'"></i>
                                    {{ formInput[row.id] ? "Nonaktifkan Chat Room" : "Aktifkan Chat Room" }}
                                  </button>
                                  <button type="button" class="dropdown-item" @click="toggleReminder(row)">
                                    <i :class="formInputReminder[row.id] ? 'fa fa-bell text-success' : 'fa fa-bell-o'"></i>
                                    {{ formInputReminder[row.id] ? "Nonaktifkan Reminder Unread" : "Aktifkan Reminder Unread" }}
                                  </button>
                                  <div class="dropdown-divider"></div>
                                  <button
                                    v-if="connectionState(row) === 'online' && isPhoneNumber(row.license_phone_number)"
                                    type="button"
                                    class="dropdown-item text-danger"
                                    @click="logout(row.license_phone_number)"
                                  >
                                    <i class="fa fa-sign-out"></i> Logout
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div class="waajo-license-cards">
                  <div v-if="loading" class="waajo-card-loading">
                    <Skeleton :count="2" />
                  </div>
                  <div v-else-if="rows.length === 0 && !listError" class="waajo-table-empty">
                    <i class="fa fa-whatsapp"></i>
                    <strong>Belum ada nomor WhatsApp</strong>
                    <span>Tambahkan nomor untuk mulai menghubungkan WhatsApp.</span>
                    <button type="button" class="btn waajo-btn-primary" @click="openAddNumber">
                      <i class="fa fa-plus"></i> Tambah Nomor
                    </button>
                  </div>
                  <article
                    v-for="(row, index) in rows"
                    :key="'card-' + (row.id || index)"
                    class="waajo-license-card"
                  >
                    <div class="waajo-license-card-head">
                      <div class="waajo-wa-number">
                        <i class="fa fa-whatsapp"></i>
                        <span>{{ displayPhone(row) }}</span>
                      </div>
                      <span class="waajo-status-pill" :class="statusClass(row)">
                        <i :class="statusIcon(row)"></i>
                        {{ statusLabel(row) }}
                      </span>
                    </div>

                    <div class="waajo-license-card-label">
                      {{ row.license_name || "Tanpa label" }}
                    </div>
                    <small v-if="licenseCreatedDate(row)" class="waajo-muted-text">
                      Ditambahkan {{ licenseCreatedDate(row) }}
                    </small>

                    <div class="waajo-license-card-meta">
                      <div>
                        <span>Masa aktif</span>
                        <strong>{{ licenseExpiryDate(row) }}</strong>
                        <small v-if="licenseExpiryRemaining(row)">{{ licenseExpiryRemaining(row) }}</small>
                        <small v-else-if="licenseExpiryStatus(row)" :class="licenseExpiryStatusClass(row)">
                          {{ licenseExpiryStatus(row) }}
                        </small>
                      </div>
                      <div>
                        <span>Status koneksi</span>
                        <strong>{{ statusLabel(row) }}</strong>
                        <small v-if="connectionState(row) === 'offline' && !isLicenseExpired(row)">Perlu scan QR</small>
                        <small v-else-if="connectionState(row) === 'unconfigured'">Nomor belum valid</small>
                      </div>
                    </div>

                    <div class="waajo-license-card-actions">
                      <router-link
                        :to="'/license/info?id=' + row.id"
                        class="btn waajo-btn-primary"
                      >
                        <i class="fa fa-eye"></i> Detail
                      </router-link>
                      <button
                        v-if="isLicenseExpired(row)"
                        type="button"
                        class="btn waajo-btn-secondary"
                        @click="goRenewal(row)"
                      >
                        <i class="fa fa-shopping-cart"></i> Perpanjang
                      </button>
                      <router-link
                        v-else-if="connectionState(row) === 'unconfigured'"
                        :to="'/license/info?id=' + row.id + '&edit=1'"
                        class="btn waajo-btn-secondary"
                      >
                        <i class="fa fa-pencil"></i> Perbaiki
                      </router-link>
                      <button
                        v-else-if="connectionState(row) === 'offline' && isPhoneNumber(row.license_phone_number)"
                        type="button"
                        class="btn waajo-btn-secondary"
                        @click="goScanQr(row)"
                      >
                        <i class="fa fa-qrcode"></i> Scan QR
                      </button>
                      <button
                        v-else-if="connectionState(row) === 'unknown' && isPhoneNumber(row.license_phone_number)"
                        type="button"
                        class="btn waajo-btn-secondary"
                        @click="refreshRowStatus(row)"
                      >
                        <i class="fa fa-refresh"></i> Cek Status
                      </button>
                    </div>
                  </article>
                </div>

                <div class="waajo-pagination">
                  <div class="waajo-pagination-info">
                    Menampilkan
                    <select v-model="serverParams.perPage" class="waajo-select waajo-select-sm" @change="onPerPageChange">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="30">30</option>
                      <option :value="50">50</option>
                    </select>
                    dari {{ totalRecords }} nomor
                  </div>
                  <div class="waajo-pagination-buttons">
                    <button type="button" class="btn waajo-btn-secondary" :disabled="currentPage <= 1" @click="onPrevChange">
                      <i class="fa fa-angle-left"></i> Sebelumnya
                    </button>
                    <span>Halaman {{ currentPage }} dari {{ totalPages }}</span>
                    <button type="button" class="btn waajo-btn-secondary" :disabled="currentPage >= totalPages" @click="onNextChange">
                      Berikutnya <i class="fa fa-angle-right"></i>
                    </button>
                  </div>
                </div>
              </section>

              <div v-if="voucherLoading" class="waajo-voucher-state">
                <i class="fa fa-spinner fa-spin"></i> Memeriksa voucher lisensi...
              </div>
              <div v-else-if="voucherError" class="waajo-voucher-state is-error">
                <span><i class="fa fa-exclamation-circle"></i> {{ voucherError }}</span>
                <button type="button" class="waajo-link-btn" @click="loadVouchers">Coba lagi</button>
              </div>
              <div v-if="hasAvailableVouchers" class="waajo-panel waajo-voucher-panel">
                <div class="waajo-panel-head">
                  <div>
                    <h4>
                      Voucher Lisensi
                      <span class="waajo-count-badge">{{ voucherCount }} tersedia</span>
                    </h4>
                    <p>Gunakan voucher lisensi Anda untuk membuat lisensi baru atau memperpanjang lisensi yang sudah ada.</p>
                  </div>
                  <router-link to="/order/active_voucher" class="waajo-small-link">
                    Lihat Voucher <i class="fa fa-angle-right"></i>
                  </router-link>
                </div>

                <div class="waajo-voucher-list">
                  <div v-for="voucher in visibleVouchers" :key="voucher.id" class="waajo-voucher-card">
                    <span class="waajo-voucher-logo"><i class="fa fa-ticket"></i></span>
                    <div class="waajo-voucher-copy">
                      <div class="waajo-voucher-code-row">
                        <strong v-if="voucherCode(voucher)">{{ voucherCode(voucher) }}</strong>
                        <button
                          v-if="voucherCode(voucher)"
                          type="button"
                          class="waajo-copy-btn"
                          title="Salin kode voucher"
                          @click="copyVoucherCode(voucher)"
                        >
                          <i class="fa fa-files-o"></i>
                        </button>
                      </div>
                      <div class="waajo-voucher-meta">
                        <span>{{ voucher.product_name || voucher.product_category_id || "-" }}</span>
                        <span v-if="voucherDuration(voucher)" class="waajo-dot">•</span>
                        <span v-if="voucherDuration(voucher)">{{ voucherDuration(voucher) }}</span>
                        <span v-if="voucherPurchaseDate(voucher)" class="waajo-dot">•</span>
                        <span v-if="voucherPurchaseDate(voucher)">Dibeli {{ voucherPurchaseDate(voucher) }}</span>
                      </div>
                    </div>
                    <span class="waajo-status-pill is-online"><i class="fa fa-check-circle"></i> Tersedia</span>
                    <div class="dropdown waajo-voucher-actions">
                      <button
                        type="button"
                        class="btn waajo-btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        :disabled="redeemSubmitting || voucherOpening"
                      >
                        <i class="fa fa-clock-o"></i> Redeem Voucher
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button type="button" class="dropdown-item" @click="openVoucherRedeem(voucher, 'new')">
                          <i class="fa fa-plus-circle text-success"></i>
                          <span><b>Buat Lisensi Baru</b><small>Gunakan voucher untuk lisensi baru</small></span>
                        </button>
                        <button type="button" class="dropdown-item" @click="openVoucherRedeem(voucher, 'extend')">
                          <i class="fa fa-clock-o text-primary"></i>
                          <span><b>Perpanjang Lisensi Existing</b><small>Tambahkan masa aktif lisensi yang sudah ada</small></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="voucherCount > visibleVouchers.length" class="waajo-voucher-more">
                    Menampilkan {{ visibleVouchers.length }} dari {{ voucherCount }} voucher.
                    <router-link to="/order/active_voucher">Lihat semua voucher</router-link>
                  </div>
                </div>
              </div>

              <div class="waajo-info-grid">
                <div class="waajo-info-box">
                  <i class="fa fa-info-circle"></i>
                  <div>
                    <strong>Tentang Voucher Lisensi</strong>
                    <p>Voucher hanya ditampilkan jika Anda memiliki voucher yang belum digunakan. Pembelian baru akan langsung aktif dan tidak memerlukan redeem voucher.</p>
                  </div>
                </div>
                <div class="waajo-info-box">
                  <i class="fa fa-shield"></i>
                  <div>
                    <strong>Keamanan &amp; Privasi</strong>
                    <p>Semua koneksi WhatsApp menggunakan sistem resmi dan aman. Scan QR dilakukan langsung pada perangkat Anda dan tidak menyimpan password.</p>
                  </div>
                </div>
              </div>
            </div>

            <aside class="waajo-guide">
              <section class="waajo-guide-card">
                <h4><i class="fa fa-question-circle"></i> Panduan Penggunaan</h4>
                <ol class="waajo-guide-steps">
                  <li v-for="(step, index) in guideSteps" :key="step.title">
                    <span>{{ index + 1 }}</span>
                    <div>
                      <strong>{{ step.title }}</strong>
                      <p>{{ step.description }}</p>
                    </div>
                  </li>
                </ol>
              </section>

              <section class="waajo-guide-card waajo-guide-qr">
                <h5><i class="fa fa-qrcode"></i> Kapan perlu scan QR?</h5>
                <ul>
                  <li>Saat status nomor offline.</li>
                  <li>Setelah logout dari perangkat.</li>
                  <li>Jika muncul notifikasi perlu autentikasi.</li>
                  <li>Pastikan WhatsApp di ponsel Anda aktif dan buka menu Perangkat Tertaut (Linked Devices).</li>
                </ul>
                <a target="_blank" href="https://waajo.gitbook.io/waajo-docs/terhubung-ke-whatsapp/cara-menghubungkan-nomor-whatsapp-ke-waajo-melalui-menu-akun-whatsapp"  class="waajo-small-link">
                  Buka panduan lengkap <i class="fa fa-angle-right"></i>
                </a>
              </section>

              <section class="waajo-guide-card waajo-buy-card">
                <span class="waajo-buy-icon"><i class="fa fa-shopping-cart"></i></span>
                <h5>Butuh lisensi tambahan?</h5>
                <p>Anda bisa membeli lisensi WhatsApp baru melalui halaman pembelian.</p>
                <router-link to="/subscriptions" class="btn waajo-btn-primary btn-block">
                  Beli Lisensi
                </router-link>
              </section>
            </aside>
          </div>
        </div>
      </div>
    </div>

    <a id="addBtn" href="#" data-toggle="modal" data-target="#add_client" style="display: none;"></a>
    <a id="extendBtn" href="#" data-toggle="modal" data-target="#extend_client" style="display: none;"></a>
    <a id="editBtn" href="#" data-toggle="modal" data-target="#edit_client" style="display: none;"></a>

    <!-- Add / redeem new license modal -->
    <div id="add_client" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ formNew ? "Buat Lisensi Baru" : "Tambah Nomor WhatsApp" }}</h5>
            <button id="btnCloseCreateLicense" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="detailVoucher" class="waajo-voucher-redeem-note">
              <i class="fa fa-ticket"></i>
              <div>
                <strong>Voucher yang akan diredeem</strong>
                <span>{{ detailVoucher.product_name || detailVoucher.product_category_id || "Voucher Lisensi" }}</span>
              </div>
            </div>
            <form @submit.prevent="createStored" class="was-validated">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Nama Lisensi <span class="text-danger">*</span></label>
                    <input v-model="formCreate.license_name" class="form-control" type="text" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Email Penagihan <span class="text-danger">*</span></label>
                    <input v-model="formCreate.license_email" class="form-control" type="email" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Nomor WhatsApp <span class="text-danger">*</span></label>
                    <input v-model="formCreate.license_phone_number" class="form-control" type="text" required />
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn waajo-btn-primary submit-btn" :disabled="redeemSubmitting">
                  <i :class="redeemSubmitting ? 'fa fa-spinner fa-spin' : 'fa fa-check'"></i>
                  {{ redeemSubmitting ? "Memproses..." : (formNew ? "Redeem & Buat Lisensi" : "Buat Lisensi") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Extend existing license modal -->
    <div id="extend_client" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Perpanjang Lisensi Existing</h5>
            <button id="btnCloseExntedLicense" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="detailVoucher" class="waajo-voucher-redeem-note">
              <i class="fa fa-ticket"></i>
              <div>
                <strong>Voucher yang akan diredeem</strong>
                <span>{{ detailVoucher.product_name || detailVoucher.product_category_id || "Voucher Lisensi" }}</span>
              </div>
            </div>
            <form @submit.prevent="actExtendLicense">
              <div class="form-group">
                <label class="col-form-label">Pilih Lisensi <span class="text-danger">*</span></label>
                <license-select v-model="licenseSelected" :multiple="false" :clearable="false" />
              </div>
              <div class="submit-section">
                <button class="btn waajo-btn-primary submit-btn" :disabled="redeemSubmitting">
                  <i :class="redeemSubmitting ? 'fa fa-spinner fa-spin' : 'fa fa-clock-o'"></i>
                  {{ redeemSubmitting ? "Memproses..." : "Perpanjang Lisensi" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit / manage number modal -->
    <div id="edit_client" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Kelola Nomor WhatsApp</h5>
            <button id="btnCloseUpdateLicense" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateStored" class="was-validated">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Nama Lisensi <span class="text-danger">*</span></label>
                    <input v-model="formUpdate.id" class="form-control" type="hidden" required />
                    <input v-model="formUpdate.license_name" class="form-control" type="text" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Email <span class="text-danger">*</span></label>
                    <input v-model="formUpdate.license_email" class="form-control" type="email" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-form-label">Nomor WhatsApp <span class="text-danger">*</span></label>
                    <input v-model="formUpdate.license_phone_number" class="form-control" type="text" required />
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn waajo-btn-primary submit-btn" :disabled="savingLicense">
                  <i :class="savingLicense ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
                  {{ savingLicense ? "Menyimpan..." : "Simpan Perubahan" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import licenseSelect from "./licenseSelect.vue";
import {
  labelPackageProduct,
  timeAgo,
  convertUTCDatetimeToUnix,
  getWhatsappNumberFromJid
} from "@/utils/helper";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    licenseSelect,
    Skeleton
  },
  data() {
    return {
      formInput: {},
      formInputReminder: {},
      serverParams: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 10
      },
      searchText: "",
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      loading: false,
      listError: "",
      listRequestId: 0,
      savingLicense: false,
      redeemSubmitting: false,
      voucherOpening: false,
      licenseSelected: null,
      currentVoucherId: "",
      detailVoucher: null,
      formNew: false,
      formExtend: false,
      formCreate: {
        license_name: "",
        license_email: "",
        license_phone_number: ""
      },
      formUpdate: {
        id: "",
        license_name: "",
        license_email: "",
        license_phone_number: ""
      },
      voucherLoading: false,
      voucherError: "",
      availableVouchers: [],
      voucherTotal: 0,
      metricsRows: [],
      metricsLoading: false,
      metricsError: "",
      metricsTotal: 0,
      licenseTotalFromApi: null,
      statusRefreshing: false
    };
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession || {};
    },
    hasAvailableVouchers() {
      return !this.voucherLoading && this.availableVouchers.length > 0;
    },
    voucherCount() {
      return Math.max(Number(this.voucherTotal) || 0, this.availableVouchers.length);
    },
    visibleVouchers() {
      return this.availableVouchers.slice(0, 3);
    },
    summaryTotal() {
      if (this.licenseTotalFromApi !== null) {
        return Number(this.licenseTotalFromApi) || 0;
      }
      if (this.metricsTotal > 0 || (!this.metricsLoading && !this.metricsError)) {
        return this.metricsTotal;
      }
      return null;
    },
    metricsComplete() {
      return !this.metricsLoading &&
        !this.metricsError &&
        this.metricsRows.length >= this.metricsTotal;
    },
    statusMetrics() {
      const result = { online: null, scan: null, active: null };
      if (!this.metricsComplete) {
        return result;
      }
      result.online = 0;
      result.scan = 0;
      result.active = 0;
      this.metricsRows.forEach(row => {
        const state = this.connectionState(row);
        if (state === "online") {
          result.online += 1;
        }
        if (
          state === "offline" &&
          this.isPhoneNumber(row.license_phone_number) &&
          !this.isLicenseExpired(row)
        ) {
          result.scan += 1;
        }
        if (this.isLicenseActive(row)) {
          result.active += 1;
        }
      });
      return result;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.serverParams.perPage));
    },
    setupSteps() {
      const steps = [];
      if (this.hasAvailableVouchers) {
        steps.push({
          title: "Voucher",
          description: this.voucherCount + " voucher tersedia",
          state: "done"
        });
        steps.push({
          title: "Redeem Lisensi",
          description: "Buat lisensi baru atau perpanjang lisensi",
          state: "active"
        });
      }
      const total = this.summaryTotal;
      steps.push({
        title: "Setup Nomor",
        description: total !== null && total > 0
          ? "Nomor WhatsApp sudah terdaftar"
          : "Tambahkan atau pilih nomor WhatsApp",
        state: total !== null && total > 0 ? "done" : "active"
      });
      const status = this.statusMetrics;
      let scanState = "neutral";
      if (status.scan !== null && status.scan > 0) {
        scanState = "active";
      } else if (status.online !== null && status.online > 0) {
        scanState = "done";
      }
      steps.push({
        title: "Scan QR",
        description: scanState === "done"
          ? "Semua nomor yang terdaftar sudah terhubung"
          : "Hubungkan nomor jika statusnya offline",
        state: scanState
      });
      return steps;
    },
    guideSteps() {
      if (this.hasAvailableVouchers) {
        return [
          {
            title: "Redeem Voucher",
            description: "Gunakan voucher lisensi lama untuk membuat lisensi baru atau memperpanjang lisensi yang sudah ada."
          },
          {
            title: "Tambah / Pilih Nomor WhatsApp",
            description: "Tambahkan nomor baru atau gunakan nomor yang sudah terdaftar."
          },
          {
            title: "Scan QR Code",
            description: "Jika status nomor offline atau perlu autentikasi, hubungkan WhatsApp melalui scan QR."
          }
        ];
      }
      return [
        {
          title: "Tambah / Pilih Nomor WhatsApp",
          description: "Tambahkan nomor baru atau gunakan nomor yang sudah terdaftar."
        },
        {
          title: "Periksa Status Koneksi",
          description: "Pastikan nomor WhatsApp sudah terhubung dan aktif."
        },
        {
          title: "Scan QR Code",
          description: "Jika nomor offline atau perlu autentikasi, hubungkan WhatsApp melalui scan QR."
        }
      ];
    }
  },
  mounted() {
    window.addEventListener("focus", this.refreshVisibleStatuses);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  async created() {
    this.formCreate.license_email = this.memberSessionArr.email || "";
    this.currentVoucherId = "";
    const voucherId = this.$route.query.voucher_id;
    const action = this.$route.query.action || "";
    if (voucherId) {
      this.currentVoucherId = voucherId;
      this.getActiveVoucher(voucherId, action);
    }
    const licenseStatus = this.$route.query.license_status;
    if (licenseStatus) {
      this.serverParams.license_status = licenseStatus;
    }
    const licensePhone = this.$route.query.license_phone_number;
    if (licensePhone) {
      this.searchText = licensePhone;
      this.serverParams.license_phone_number = licensePhone;
    }
    await Promise.all([
      this.loadItems(),
      this.loadVouchers(),
      this.loadSummary()
    ]);
  },
  filters: {
    labelPackageProduct(value) {
      return labelPackageProduct(value);
    }
  },
  watch: {
    "$route.query.voucher_id"(voucherId) {
      if (voucherId) {
        this.currentVoucherId = voucherId;
        this.getActiveVoucher(voucherId, this.$route.query.action || "");
      }
    },
    "$route.query.license_phone_number"(phone) {
      if (phone && phone !== this.serverParams.license_phone_number) {
        this.searchText = phone;
        this.serverParams.license_name = "";
        this.serverParams.license_phone_number = phone;
        this.searchData();
      }
    },
    "$route.query.license_status"(status) {
      if (typeof status !== "undefined" && status !== this.serverParams.license_status) {
        this.serverParams.license_status = status || "";
        this.searchData();
      }
    }
  },
  methods: {
    isPhoneNumber(value) {
      return /^[0-9]{10,15}$/.test(String(value || ""));
    },
    displayPhone(row) {
      if (!row || !row.license_phone_number) {
        return "-";
      }
      const phone = String(row.license_phone_number);
      return getWhatsappNumberFromJid(phone) || phone;
    },
    connectionState(row) {
      if (!row || !this.isPhoneNumber(row.license_phone_number)) {
        return "unconfigured";
      }
      const raw = row.is_online_status;
      if (raw === null || typeof raw === "undefined" || raw === "") {
        return "unknown";
      }
      const status = Number(raw);
      if (status === 1) {
        return "online";
      }
      if (status === 0) {
        return "offline";
      }
      return "unknown";
    },
    statusLabel(row) {
      const state = this.connectionState(row);
      if (state === "online") {
        return "Online";
      }
      if (state === "offline") {
        return "Offline";
      }
      if (state === "unknown") {
        return "Belum diketahui";
      }
      return "Belum diatur";
    },
    statusClass(row) {
      const state = this.connectionState(row);
      if (state === "online") {
        return "is-online";
      }
      if (state === "offline") {
        return "is-offline";
      }
      if (state === "unknown") {
        return "is-unknown";
      }
      return "is-neutral";
    },
    statusIcon(row) {
      const state = this.connectionState(row);
      if (state === "online") {
        return "fa fa-check-circle";
      }
      if (state === "offline") {
        return "fa fa-exclamation-circle";
      }
      if (state === "unknown") {
        return "fa fa-question-circle";
      }
      return "fa fa-circle-o";
    },
    isLicenseActive(row) {
      if (!row) {
        return false;
      }
      if (this.isLicenseExpired(row)) {
        return false;
      }
      if (row.status_label) {
        return String(row.status_label).toLowerCase() === "active";
      }
      return Number(row.is_unlimited) === 1;
    },
    isLicenseExpired(row) {
      if (!row || Number(row.is_unlimited) === 1) {
        return false;
      }
      const statusLabel = String(row.status_label || "").toLowerCase();
      const licenseStatus = String(row.license_status || "").toLowerCase();
      if (statusLabel === "expired" || licenseStatus === "expired") {
        return true;
      }
      if (statusLabel === "inactive" || licenseStatus === "inactive") {
        return true;
      }
      if (Number(row.is_free) === 1 || statusLabel === "draft" || licenseStatus === "draft") {
        return false;
      }
      const rawExpiry = row.license_masa_aktif;
      if (!rawExpiry) {
        return false;
      }
      const expiry = new Date(rawExpiry);
      if (isNaN(expiry.getTime())) {
        return false;
      }
      expiry.setHours(23, 59, 59, 999);
      return expiry.getTime() < Date.now();
    },
    licenseProductLabel(row) {
      if (!row) {
        return "-";
      }
      return row.last_product_name || row.product_name || row.last_product_code || "-";
    },
    licenseCreatedDate(row) {
      if (!row || !row.license_create_datetime) {
        return "";
      }
      return this.formatShortDate(row.license_create_datetime);
    },
    formatShortDate(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      const months = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
      return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
    },
    licenseExpiryDate(row) {
      if (!row) {
        return "-";
      }
      if (Number(row.is_unlimited) === 1) {
        return "Tanpa batas";
      }
      return this.formatShortDate(row.license_masa_aktif) || "-";
    },
    licenseExpiryRemaining(row) {
      if (!row || Number(row.is_unlimited) === 1 || !row.license_masa_aktif) {
        return "";
      }
      if (!this.isLicenseActive(row) || this.isLicenseExpired(row)) {
        return "";
      }
      try {
        return timeAgo(convertUTCDatetimeToUnix(row.license_masa_aktif + " 23:59:59"));
      } catch (error) {
        return "";
      }
    },
    licenseExpiryStatus(row) {
      if (!row) {
        return "";
      }
      if (Number(row.is_unlimited) === 1) {
        return "Unlimited";
      }
      if (Number(row.is_free) === 1) {
        return "Free";
      }
      if (this.isLicenseExpired(row)) {
        return "Expired";
      }
      if (row.license_masa_aktif === "1990-01-01" && !this.isLicenseActive(row)) {
        return "Inactive";
      }
      const label = String(row.status_label || "").toLowerCase();
      if (label === "expired") {
        return "Expired";
      }
      if (label === "draft") {
        return "Draft";
      }
      return "";
    },
    licenseExpiryStatusClass(row) {
      const label = String(row && row.status_label || "").toLowerCase();
      if (this.isLicenseExpired(row) || label === "expired") {
        return "is-expired";
      }
      if (label === "draft") {
        return "is-draft";
      }
      return "is-info";
    },
    voucherCode(voucher) {
      return voucher && (voucher.code || voucher.voucher_code)
        ? voucher.code || voucher.voucher_code
        : "";
    },
    voucherDuration(voucher) {
      if (!voucher) {
        return "";
      }
      const category = voucher.product_category_id || "";
      const label = labelPackageProduct(category);
      if (label && label !== category) {
        return label;
      }
      if (Number(voucher.activation_days) > 0) {
        return voucher.activation_days + " hari";
      }
      return "";
    },
    voucherPurchaseDate(voucher) {
      if (!voucher || !voucher.create_datetime) {
        return "";
      }
      return this.formatShortDate(voucher.create_datetime);
    },
    async copyVoucherCode(voucher) {
      const code = this.voucherCode(voucher);
      if (!code) {
        return;
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const area = document.createElement("textarea");
          area.value = code;
          document.body.appendChild(area);
          area.select();
          document.execCommand("copy");
          document.body.removeChild(area);
        }
        this.notify("Kode voucher disalin.", "success");
      } catch (error) {
        this.notify("Kode voucher tidak dapat disalin.", "error");
      }
    },
    async loadItems() {
      const requestId = this.listRequestId + 1;
      this.listRequestId = requestId;
      this.loading = true;
      this.listError = "";
      const params = Object.assign({}, this.serverParams, {
        page: Math.max(0, (this.currentPage - 1) * this.serverParams.perPage)
      });
      try {
        const response = await this.$store.dispatch("license/getLicenseList", params);
        if (requestId !== this.listRequestId) {
          return;
        }
        const data = response.data || {};
        this.totalRecords = Number(data.totalRecords) || 0;
        this.rowPage = data.page;
        const rows = Array.isArray(data.data) ? data.data : [];
        this.rows = rows;
        rows.forEach(row => {
          this.$set(this.formInput, row.id, Number(row.is_chat) === 1);
          this.$set(this.formInputReminder, row.id, Number(row.is_chat_unread_notif) === 1);
          if (this.isPhoneNumber(row.license_phone_number)) {
            this.isOnline(row.id, row.license_phone_number);
          } else {
            this.setOnlineStatus(row.id, null);
          }
        });
      } catch (error) {
        if (requestId === this.listRequestId) {
          this.listError = this.getErrorMessage(error, "Daftar nomor WhatsApp belum dapat dimuat.");
        }
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false;
        }
      }
    },
    async loadSummary() {
      this.metricsLoading = true;
      this.metricsError = "";
      try {
        const total = await this.$store.dispatch("member/getLicenseTotal");
        this.licenseTotalFromApi = Number(total) || 0;
      } catch (error) {
        this.licenseTotalFromApi = null;
      }
      await this.loadMetrics();
    },
    async loadMetrics() {
      this.metricsLoading = true;
      this.metricsError = "";
      const knownTotal = this.licenseTotalFromApi !== null
        ? Number(this.licenseTotalFromApi) || 0
        : 0;
      const perPage = knownTotal > 0
        ? Math.min(Math.max(knownTotal, 20), 500)
        : 200;
      try {
        const response = await this.$store.dispatch("license/getLicenseList", {
          license_name: "",
          license_phone_number: "",
          license_status: "",
          page: 0,
          perPage: perPage
        });
        const data = response.data || {};
        this.metricsRows = Array.isArray(data.data) ? data.data : [];
        this.metricsTotal = Number(data.totalRecords) || this.metricsRows.length;
        if (this.licenseTotalFromApi === null) {
          this.licenseTotalFromApi = this.metricsTotal;
        }
      } catch (error) {
        this.metricsError = this.getErrorMessage(error, "Ringkasan status nomor belum dapat dimuat.");
      } finally {
        this.metricsLoading = false;
      }
    },
    async loadVouchers() {
      this.voucherLoading = true;
      this.voucherError = "";
      let voucherTotal = null;
      try {
        voucherTotal = await this.$store.dispatch("member/getActiveVoucherTotal");
        voucherTotal = Number(voucherTotal) || 0;
      } catch (error) {
        voucherTotal = null;
      }
      try {
        const memberId = this.memberSessionArr.id;
        const memberEmail = this.memberSessionArr.email || "";
        const response = await this.$store.dispatch("order/voucherList", {
          columnFilters: {
            status: 1,
            member_keywords: memberEmail
          },
          page: 0,
          perPage: 500
        });
        const data = response.data || {};
        const rows = Array.isArray(data.data) ? data.data : [];
        this.availableVouchers = rows.filter(voucher => {
          if (Number(voucher.redeem_status) !== 1) {
            return false;
          }
          if (
            typeof voucher.detail_is_license !== "undefined" &&
            voucher.detail_is_license !== null &&
            Number(voucher.detail_is_license) !== 1
          ) {
            return false;
          }
          if (memberId && typeof voucher.network_id !== "undefined" && voucher.network_id !== null) {
            return String(voucher.network_id) === String(memberId);
          }
          return true;
        });
        const fetchedAll = rows.length < 500;
        this.voucherTotal = fetchedAll
          ? this.availableVouchers.length
          : Math.max(voucherTotal || 0, this.availableVouchers.length);
        if (!fetchedAll && this.availableVouchers.length === 0 && voucherTotal > 0) {
          this.voucherError = "Voucher tersedia, tetapi daftar voucher belum dapat ditampilkan.";
        }
      } catch (error) {
        this.voucherError = this.getErrorMessage(error, "Voucher lisensi belum dapat dimuat.");
      } finally {
        this.voucherLoading = false;
      }
    },
    async refreshAccountData() {
      await this.loadItems();
      await this.loadSummary();
      await this.loadVouchers();
    },
    async applySearch() {
      const text = String(this.searchText || "").trim();
      if (/^[+0-9\s-]{5,}$/.test(text)) {
        this.serverParams.license_name = "";
        this.serverParams.license_phone_number = text.replace(/\D/g, "");
      } else {
        this.serverParams.license_name = text;
        this.serverParams.license_phone_number = "";
      }
      await this.searchData();
    },
    async resetSearch() {
      this.searchText = "";
      this.serverParams.license_name = "";
      this.serverParams.license_phone_number = "";
      this.serverParams.license_status = "";
      await this.searchData();
    },
    async searchData() {
      this.currentPage = 1;
      await this.loadItems();
    },
    async onPageChange(page) {
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        await this.loadItems();
      }
    },
    async onPrevChange() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        await this.loadItems();
      }
    },
    async onPerPageChange() {
      this.currentPage = 1;
      await this.loadItems();
    },
    async isOnline(licenseId, phone) {
      if (!this.isPhoneNumber(phone)) {
        this.setOnlineStatus(licenseId, null);
        return null;
      }
      try {
        const response = await this.$store.dispatch("omniwa/isOnline", phone);
        const data = response.data || {};
        const status = Number(data.status) === 1 ? 1 : 0;
        this.setOnlineStatus(licenseId, status, data.message || "");
        return status;
      } catch (error) {
        return null;
      }
    },
    setOnlineStatus(licenseId, status, message) {
      [this.rows, this.metricsRows].forEach(list => {
        const index = list.findIndex(row => row.id === licenseId);
        if (index >= 0) {
          this.$set(list[index], "is_online_status", status);
          if (typeof message !== "undefined") {
            this.$set(list[index], "status_message", message);
          }
        }
      });
    },
    async refreshRowStatus(row) {
      if (!row) {
        return;
      }
      const status = await this.isOnline(row.id, row.license_phone_number);
      if (status === null) {
        this.notify("Status nomor belum dapat diperiksa.", "error");
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.refreshVisibleStatuses();
      }
    },
    refreshVisibleStatuses() {
      if (this.loading || this.statusRefreshing || !this.rows.length) {
        return;
      }
      this.statusRefreshing = true;
      const requests = this.rows
        .filter(row => this.isPhoneNumber(row.license_phone_number))
        .map(row => this.isOnline(row.id, row.license_phone_number));
      Promise.all(requests).then(
        () => {
          this.statusRefreshing = false;
        },
        () => {
          this.statusRefreshing = false;
        }
      );
    },
    openAddNumber() {
      this.currentVoucherId = "";
      this.detailVoucher = null;
      this.formNew = false;
      this.formExtend = false;
      this.licenseSelected = null;
      this.formCreate = {
        license_name: "",
        license_email: this.memberSessionArr.email || "",
        license_phone_number: ""
      };
      this.showModal("add_client");
    },
    async openEditLicense(row) {
      if (!row || this.savingLicense) {
        return;
      }
      this.savingLicense = true;
      try {
        const response = await this.$store.dispatch("license/getLicenseById", row.id);
        this.formUpdate = Object.assign({}, response.data || {});
        this.showModal("edit_client");
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Data nomor belum dapat dimuat."), "error");
      } finally {
        this.savingLicense = false;
      }
    },
    async getActiveVoucher(id, action) {
      if (!id) {
        return null;
      }
      this.savingLicense = true;
      try {
        const response = await this.$store.dispatch("order/getActiveVoucher", id);
        this.detailVoucher = response.data || null;
        if (!this.detailVoucher) {
          throw new Error("Voucher tidak ditemukan.");
        }
        this.formNew = action === "new";
        this.formExtend = action === "extend";
        if (this.formNew) {
          this.showModal("add_client");
        } else if (this.formExtend) {
          this.licenseSelected = null;
          this.showModal("extend_client");
        }
        return this.detailVoucher;
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Voucher belum dapat dibuka."), "error");
        this.loadVouchers();
        return null;
      } finally {
        this.savingLicense = false;
      }
    },
    openVoucherRedeem(voucher, action) {
      if (!voucher || this.redeemSubmitting || this.voucherOpening) {
        return;
      }
      this.currentVoucherId = voucher.id;
      this.detailVoucher = voucher;
      this.formNew = action === "new";
      this.formExtend = action === "extend";
      this.licenseSelected = null;
      this.formCreate = {
        license_name: "",
        license_email: this.memberSessionArr.email || "",
        license_phone_number: ""
      };
      this.voucherOpening = true;
      this.getActiveVoucher(voucher.id, action).then(
        () => {
          this.voucherOpening = false;
        },
        () => {
          this.voucherOpening = false;
        }
      );
    },
    async createStored() {
      if (this.redeemSubmitting) {
        return;
      }
      if (!this.formCreate.license_name || !this.formCreate.license_email || !this.formCreate.license_phone_number) {
        this.notify("Lengkapi nama lisensi, email, dan nomor WhatsApp.", "warning");
        return;
      }
      this.redeemSubmitting = true;
      try {
        const confirmation = await this.$fire({
          title: "Lanjutkan pembuatan lisensi?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Ya",
          denyButtonText: "Batal"
        });
        if (!confirmation || confirmation.value !== true) {
          return;
        }
        const response = await this.$store.dispatch("license/createStored", this.formCreate);
        const data = response.data || {};
        if (this.currentVoucherId) {
          try {
            await this.$store.dispatch("order/extendLicense", {
              license_id: data.id,
              voucher_id: this.currentVoucherId
            });
          } catch (extendError) {
            this.closeModal("add_client");
            await this.refreshAccountData();
            this.notify(
              "Lisensi berhasil dibuat, tetapi voucher belum berhasil diredeem. Silakan gunakan opsi Perpanjang Lisensi Existing untuk menyelesaikan redeem.",
              "warning"
            );
            return;
          }
          this.markVoucherConsumed(this.currentVoucherId);
          this.notify("Lisensi berhasil dibuat dan voucher berhasil diredeem.", "success");
          this.closeModal("add_client");
          await this.refreshAccountData();
          if (data.id) {
            this.$router.push("/license/info?id=" + data.id + "&show_qr_code=1");
          }
        } else {
          this.notify(
            (response.msg || "Lisensi berhasil dibuat") +
              ". Untuk menggunakan lisensi, lanjutkan pembelian paket aktivasi.",
            "success"
          );
          this.closeModal("add_client");
          await this.refreshAccountData();
          if (data.id) {
            this.$router.push("/subscriptions?license_id=" + data.id);
          }
        }
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Lisensi belum dapat diproses."), "error");
      } finally {
        this.redeemSubmitting = false;
      }
    },
    async actExtendLicense() {
      if (this.redeemSubmitting) {
        return;
      }
      if (!this.licenseSelected || !this.licenseSelected.id) {
        this.notify("Pilih lisensi yang ingin diperpanjang.", "warning");
        return;
      }
      this.redeemSubmitting = true;
      try {
        const confirmation = await this.$fire({
          title: "Perpanjang lisensi ini?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Ya",
          denyButtonText: "Batal"
        });
        if (!confirmation || confirmation.value !== true) {
          return;
        }
        await this.$store.dispatch("order/extendLicense", {
          license_id: this.licenseSelected.id,
          voucher_id: this.currentVoucherId
        });
        this.markVoucherConsumed(this.currentVoucherId);
        this.notify("Lisensi berhasil diperpanjang dan voucher berhasil diredeem.", "success");
        this.closeModal("extend_client");
        await this.refreshAccountData();
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Lisensi belum dapat diperpanjang."), "error");
      } finally {
        this.redeemSubmitting = false;
      }
    },
    async updateStored() {
      if (this.savingLicense) {
        return;
      }
      if (!this.formUpdate.id) {
        return;
      }
      this.savingLicense = true;
      try {
        const confirmation = await this.$fire({
          title: "Simpan perubahan nomor WhatsApp?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Ya",
          denyButtonText: "Batal"
        });
        if (!confirmation || confirmation.value !== true) {
          return;
        }
        const response = await this.$store.dispatch("license/updateStored", this.formUpdate);
        this.notify(response.msg || "Perubahan berhasil disimpan.", "success");
        this.closeModal("edit_client");
        await this.refreshAccountData();
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Perubahan belum dapat disimpan."), "error");
      } finally {
        this.savingLicense = false;
      }
    },
    async toggleChatRoom(row) {
      if (!row || this.savingLicense) {
        return;
      }
      const next = !this.formInput[row.id];
      this.$set(this.formInput, row.id, next);
      this.savingLicense = true;
      try {
        await this.$store.dispatch(
          next ? "license/chatRoomEnable" : "license/chatRoomDisable",
          { license_id: row.id }
        );
        await this.loadItems();
      } catch (error) {
        this.$set(this.formInput, row.id, !next);
        this.notify(this.getErrorMessage(error, "Pengaturan Chat Room gagal diubah."), "error");
      } finally {
        this.savingLicense = false;
      }
    },
    async toggleReminder(row) {
      if (!row || this.savingLicense) {
        return;
      }
      const next = !this.formInputReminder[row.id];
      this.$set(this.formInputReminder, row.id, next);
      this.savingLicense = true;
      try {
        await this.$store.dispatch(
          next ? "license/reminderUnreadChatRoomEnable" : "license/reminderUnreadChatRoomDisable",
          { license_id: row.id }
        );
        await this.loadItems();
      } catch (error) {
        this.$set(this.formInputReminder, row.id, !next);
        this.notify(this.getErrorMessage(error, "Pengaturan reminder gagal diubah."), "error");
      } finally {
        this.savingLicense = false;
      }
    },
    async logout(phone) {
      if (!this.isPhoneNumber(phone)) {
        return;
      }
      const confirmation = await this.$fire({
        title: "Logout sesi WhatsApp ini?",
        text: "Sesi WhatsApp pada nomor ini akan dihentikan.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        denyButtonText: "Batal"
      });
      if (!confirmation || confirmation.value !== true) {
        return;
      }
      try {
        const response = await this.$store.dispatch("omniwa/logout", phone);
        this.notify((response && response.msg) || "Sesi berhasil logout.", "success");
        await this.loadItems();
        await this.loadMetrics();
      } catch (error) {
        this.notify(this.getErrorMessage(error, "Sesi belum dapat logout."), "error");
      }
    },
    goScanQr(row) {
      if (!row || !row.id) {
        return;
      }
      this.$router.push({
        path: "/license/info",
        query: { id: row.id, show_qr_code: "1" }
      });
    },
    goChatRoom(row) {
      if (!row || !row.id) {
        return;
      }
      this.$router.push("/omni/connect-to-agent-owner?license_id=" + row.id);
    },
    goApiInfo(row) {
      if (row && row.id) {
        this.$router.push("/license/info?id=" + row.id);
      }
    },
    goRenewal(row) {
      if (!row || !row.id) {
        return;
      }
      const query = row.last_product_code
        ? "?license_id=" + row.id + "&code=" + row.last_product_code
        : "?license_id=" + row.id;
      this.$router.push("/prepare-order" + query);
    },
    markVoucherConsumed(voucherId) {
      if (!voucherId) {
        return;
      }
      this.availableVouchers = this.availableVouchers.filter(voucher => String(voucher.id) !== String(voucherId));
      this.voucherTotal = Math.max(0, Number(this.voucherTotal || 1) - 1);
      this.currentVoucherId = "";
      this.detailVoucher = null;
    },
    showModal(id) {
      const triggerIds = {
        add_client: "addBtn",
        extend_client: "extendBtn",
        edit_client: "editBtn"
      };
      try {
        const jq = window.jQuery || window.$;
        if (jq && jq.fn && jq.fn.modal) {
          jq("#" + id).modal("show");
          return;
        }
        const trigger = document.getElementById(triggerIds[id]);
        if (trigger) {
          trigger.click();
        }
      } catch (error) {
        const trigger = document.getElementById(triggerIds[id]);
        if (trigger) {
          trigger.click();
        }
      }
    },
    closeModal(id) {
      try {
        const jq = window.jQuery || window.$;
        if (jq && jq.fn && jq.fn.modal) {
          jq("#" + id).modal("hide");
          return;
        }
        const closeButtonIds = {
          add_client: "btnCloseCreateLicense",
          extend_client: "btnCloseExntedLicense",
          edit_client: "btnCloseUpdateLicense"
        };
        const closeButton = document.getElementById(closeButtonIds[id]);
        if (closeButton) {
          closeButton.click();
        }
      } catch (error) {
        // No-op when Bootstrap is already handling the modal.
      }
    },
    notify(text, type) {
      this.$fire({
        title: type === "error" ? "Gagal" : type === "warning" ? "Perhatian" : "Berhasil",
        text: text,
        type: type || "success",
        timer: 3000
      });
    },
    getErrorMessage(error, fallback) {
      return (error && error.response && error.response.data && error.response.data.msg) ||
        (error && error.message) ||
        fallback;
    }
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.refreshVisibleStatuses);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.serverParams.license_status = "";
  },
  name: "licenseList"
};
</script>

<style scoped>
.waajo-account-page {
  padding-top: 4px;
  padding-bottom: 28px;
  color: #344054;
}

.waajo-account-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 20px;
}

.waajo-account-heading-copy h3 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.waajo-account-heading-copy p {
  margin: 0 0 9px;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.waajo-account-heading-copy .breadcrumb {
  margin: 0;
  background: transparent;
  padding: 0;
  font-size: 13px;
}

.waajo-account-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 20px;
  align-items: start;
}

.waajo-account-main {
  min-width: 0;
}

.waajo-account-main > * + * {
  margin-top: 16px;
}

.waajo-setup-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.waajo-setup-strip-title {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 9px;
  color: #667085;
}

.waajo-setup-strip-title > i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  color: #2e90fa;
  background: #eff8ff;
  border-radius: 9px;
  font-size: 14px;
}

.waajo-setup-strip-title strong {
  display: block;
  color: #344054;
  font-size: 11px;
}

.waajo-setup-strip-title small {
  display: block;
  margin-top: 1px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-setup-steps {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.waajo-setup-step {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 7px 9px;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  background: #f8fafc;
}

.waajo-setup-step > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 21px;
  width: 21px;
  height: 21px;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
}

.waajo-setup-step strong {
  display: block;
  color: #475467;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
}

.waajo-setup-step small {
  display: block;
  max-width: 165px;
  margin-top: 1px;
  overflow: hidden;
  color: #98a2b3;
  font-size: 8px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-setup-step.is-active {
  background: #fffaf0;
  border-color: #f6d49b;
}

.waajo-setup-step.is-active > span {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
}

.waajo-setup-step.is-active strong { color: #b36b00; }

.waajo-setup-step.is-done {
  background: #f2fdf7;
  border-color: #bbf7d0;
}

.waajo-setup-step.is-done > span {
  color: #ffffff;
  background: #12b76a;
  border-color: #12b76a;
}

.waajo-setup-step.is-done strong { color: #067647; }

.waajo-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.waajo-stat-card {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.waajo-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 11px;
  font-size: 17px;
}

.waajo-stat-icon.is-wa { color: #128c7e; background: #e7f8f2; }
.waajo-stat-icon.is-online { color: #12b76a; background: #eafaf1; }
.waajo-stat-icon.is-alert { color: #d92d20; background: #fff1f0; }
.waajo-stat-icon.is-license { color: #2e90fa; background: #eff8ff; }

.waajo-stat-copy {
  min-width: 0;
}

.waajo-stat-label {
  display: block;
  overflow: hidden;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-stat-copy strong {
  display: block;
  margin: 2px 0;
  color: #101828;
  font-size: 22px;
  line-height: 1.2;
}

.waajo-stat-copy small {
  display: block;
  overflow: hidden;
  color: #98a2b3;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-panel {
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.waajo-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 17px 18px 13px;
}

.waajo-panel-head h4 {
  margin: 0 0 5px;
  color: #101828;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.35;
}

.waajo-panel-head p {
  margin: 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
}

.waajo-count-badge {
  display: inline-flex;
  margin-left: 5px;
  padding: 2px 7px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 700;
  vertical-align: middle;
}

.waajo-small-link {
  flex: 0 0 auto;
  color: #e08b13;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}

.waajo-small-link:hover { color: #b36b00; text-decoration: none; }

.waajo-voucher-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 15px;
  color: #667085;
  background: #fffdf8;
  border: 1px solid #f6e3bd;
  border-radius: 12px;
  font-size: 11px;
}

.waajo-voucher-state.is-error {
  color: #b42318;
  background: #fff7f6;
  border-color: #fecdca;
}

.waajo-voucher-panel {
  border-color: #f6e3bd;
  background: linear-gradient(180deg, #fffdf8 0%, #ffffff 100%);
}

.waajo-voucher-list {
  padding: 0 14px 14px;
}

.waajo-voucher-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #f0e7d8;
  border-radius: 12px;
}

.waajo-voucher-card + .waajo-voucher-card {
  margin-top: 8px;
}

.waajo-voucher-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  color: #e08b13;
  background: #fff4e5;
  border-radius: 9px;
  font-size: 16px;
}

.waajo-voucher-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.waajo-voucher-code-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.waajo-voucher-code-row strong {
  overflow: hidden;
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-copy-btn {
  padding: 0;
  color: #98a2b3;
  background: transparent;
  border: 0;
  font-size: 11px;
  cursor: pointer;
}

.waajo-copy-btn:hover { color: #e08b13; }

.waajo-voucher-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 3px;
  color: #667085;
  font-size: 10px;
}

.waajo-dot { color: #d0d5dd; }

.waajo-voucher-more {
  padding: 9px 2px 0;
  color: #667085;
  font-size: 9px;
}

.waajo-voucher-more a {
  color: #e08b13;
  font-weight: 700;
}

.waajo-voucher-actions {
  flex: 0 0 auto;
}

.waajo-voucher-actions .dropdown-menu {
  min-width: 240px;
  padding: 6px;
  border-color: #e7edf5;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.14);
}

.waajo-voucher-actions .dropdown-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px;
  color: #344054;
  border-radius: 7px;
  white-space: normal;
}

.waajo-voucher-actions .dropdown-item i { margin-top: 3px; }

.waajo-voucher-actions .dropdown-item span {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.waajo-voucher-actions .dropdown-item b {
  font-size: 10px;
}

.waajo-voucher-actions .dropdown-item small {
  color: #98a2b3;
  font-size: 9px;
}

.waajo-number-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.waajo-search-box {
  position: relative;
  display: flex;
  align-items: center;
  width: 220px;
  height: 38px;
  padding: 0 11px;
  color: #98a2b3;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 9px;
}

.waajo-search-box input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 0 0 8px;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 13px;
}

.waajo-search-box input::placeholder { color: #98a2b3; }

.waajo-select {
  width: auto;
  height: 38px;
  padding: 0 28px 0 11px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 13px;
}

.waajo-select-sm {
  height: 32px;
  padding: 0 24px 0 9px;
  margin: 0 4px;
}

.waajo-btn-primary,
.waajo-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.waajo-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
  box-shadow: 0 3px 8px rgba(243, 156, 18, 0.18);
}

.waajo-btn-primary:hover,
.waajo-btn-primary:focus {
  color: #ffffff;
  background: #e08b13;
  border-color: #e08b13;
}

.waajo-btn-secondary {
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
}

.waajo-btn-secondary:hover,
.waajo-btn-secondary:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
}

.waajo-icon-btn {
  width: 38px;
  padding: 0;
}

.waajo-number-table-wrap {
  padding: 0 8px;
  overflow: visible !important;
}

.waajo-number-table {
  min-width: 1000px;
  color: #475467;
  font-size: 14px;
  line-height: 1.45;
}

.waajo-number-table thead th {
  padding: 12px 12px;
  color: #667085;
  background: #f8fafc;
  border-bottom: 1px solid #e7edf5;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.waajo-number-table tbody td {
  padding: 15px 12px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f4f8;
}

.waajo-number-table tbody tr:last-child td { border-bottom: 0; }

.waajo-row-number { color: #98a2b3; font-size: 12px; }

.waajo-wa-number {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
}

.waajo-wa-number i { color: #25d366; font-size: 16px; }

.waajo-license-name {
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.waajo-muted-text {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.4;
}

.waajo-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.waajo-status-pill.is-online {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.waajo-status-pill.is-offline {
  color: #b42318;
  background: #fff1f0;
  border-color: #fecdca;
}

.waajo-status-pill.is-unknown {
  color: #b54708;
  background: #fffaeb;
  border-color: #fedf89;
}

.waajo-status-pill.is-neutral {
  color: #667085;
  background: #f8fafc;
  border-color: #e7edf5;
}

.waajo-license-expiry span {
  display: block;
  color: #475467;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.waajo-license-expiry small {
  display: block;
  margin-top: 3px;
  color: #12b76a;
  font-size: 12px;
  line-height: 1.4;
}

.waajo-license-expiry small.is-expired { color: #d92d20; }
.waajo-license-expiry small.is-draft { color: #b54708; }
.waajo-license-expiry small.is-info { color: #2e90fa; }

.waajo-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  white-space: nowrap;
}

.waajo-row-actions .btn {
  height: 36px;
  padding: 0 12px;
  font-size: 13px;
}

.waajo-row-actions .waajo-row-detail {
  min-width: 76px;
}

.waajo-btn-scan {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
}

.waajo-btn-scan:hover,
.waajo-btn-scan:focus {
  color: #8f5600;
  background: #fff3dd;
  border-color: #efc177;
}

.waajo-btn-fix-number {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #8f5600;
  background: #fff8e8;
  border-color: #f3c777;
  border-radius: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.waajo-btn-fix-number:hover,
.waajo-btn-fix-number:focus {
  color: #6f4200;
  background: #ffefd1;
  border-color: #eab65f;
}

.waajo-row-options .dropdown-menu {
  min-width: 240px;
  padding: 7px;
  border-color: #e7edf5;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.14);
}

.waajo-row-options .dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  color: #475467;
  border-radius: 7px;
  font-size: 13px;
}

.waajo-table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 28px 10px;
  color: #667085;
  text-align: center;
}

.waajo-table-empty > i {
  color: #f39c12;
  font-size: 27px;
}

.waajo-table-empty strong { color: #344054; font-size: 15px; }
.waajo-table-empty span { font-size: 13px; }

.waajo-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid #f1f4f8;
}

.waajo-pagination-info,
.waajo-pagination-buttons {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 13px;
}

.waajo-pagination-buttons .btn {
  height: 34px;
  padding: 0 11px;
  font-size: 13px;
}

.waajo-inline-note,
.waajo-inline-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 12px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 10px;
}

.waajo-inline-error {
  color: #b42318;
  background: #fff7f6;
  border-color: #fecdca;
}

.waajo-link-btn {
  padding: 0;
  color: inherit;
  background: transparent;
  border: 0;
  font-size: 10px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.waajo-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.waajo-info-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 13px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}

.waajo-info-box > i {
  margin-top: 2px;
  color: #2e90fa;
  font-size: 16px;
}

.waajo-info-box strong {
  display: block;
  margin-bottom: 3px;
  color: #344054;
  font-size: 13px;
}

.waajo-info-box p {
  margin: 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.waajo-guide {
  position: sticky;
  top: 74px;
  min-width: 0;
}

.waajo-guide-card {
  padding: 15px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.waajo-guide-card + .waajo-guide-card { margin-top: 12px; }

.waajo-guide-card h4,
.waajo-guide-card h5 {
  margin: 0 0 10px;
  color: #344054;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.waajo-guide-card h4 i,
.waajo-guide-card h5 i {
  margin-right: 5px;
  color: #2e90fa;
}

.waajo-guide-steps {
  padding: 0;
  margin: 0;
  list-style: none;
}

.waajo-guide-steps li {
  display: flex;
  align-items: flex-start;
  gap: 9px;
}

.waajo-guide-steps li + li { margin-top: 13px; }

.waajo-guide-steps li > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  color: #ffffff;
  background: #2e90fa;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
}

.waajo-guide-steps strong {
  display: block;
  color: #344054;
  font-size: 12px;
  line-height: 1.4;
}

.waajo-guide-steps p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.waajo-guide-qr ul {
  padding-left: 16px;
  margin: 0 0 10px;
  color: #667085;
  font-size: 12px;
  line-height: 1.7;
}

.waajo-buy-card { background: #fffdf8; border-color: #f6e3bd; }

.waajo-buy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-bottom: 7px;
  color: #e08b13;
  background: #fff4e5;
  border-radius: 8px;
  font-size: 14px;
}

.waajo-buy-card p {
  margin: 0 0 10px;
  color: #667085;
  font-size: 9px;
  line-height: 1.55;
}

.waajo-voucher-redeem-note {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 15px;
  padding: 10px;
  color: #475467;
  background: #fffaf0;
  border: 1px solid #f6e3bd;
  border-radius: 9px;
}

.waajo-voucher-redeem-note i { color: #e08b13; font-size: 18px; }
.waajo-voucher-redeem-note div { display: flex; flex-direction: column; gap: 2px; }
.waajo-voucher-redeem-note strong { font-size: 10px; }
.waajo-voucher-redeem-note span { color: #667085; font-size: 10px; }

.waajo-number-head { align-items: center; }

@media (max-width: 1350px) {
  .waajo-account-layout { grid-template-columns: minmax(0, 1fr); }
  .waajo-guide { position: static; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
  .waajo-guide-card + .waajo-guide-card { margin-top: 0; }
  .waajo-guide-qr { grid-column: 1 / -1; }
}

@media (max-width: 1199px) {
  .waajo-number-table-wrap { overflow-x: auto !important; }
}

@media (max-width: 767px) {
  .waajo-account-heading { flex-direction: column; }
  .waajo-account-heading .waajo-btn-primary { align-self: flex-start; }
  .waajo-stat-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .waajo-setup-strip { flex-direction: column; align-items: flex-start; }
  .waajo-setup-steps { justify-content: flex-start; }
  .waajo-panel-head { flex-direction: column; }
  .waajo-number-tools { justify-content: flex-start; width: 100%; }
  .waajo-search-box { flex: 1 1 150px; width: auto; }
  .waajo-voucher-card { align-items: flex-start; flex-wrap: wrap; }
  .waajo-voucher-actions { margin-left: 46px; }
  .waajo-info-grid { grid-template-columns: minmax(0, 1fr); }
  .waajo-guide { display: block; }
  .waajo-guide-card + .waajo-guide-card { margin-top: 12px; }
  .waajo-pagination { flex-direction: column; align-items: flex-start; }
  .waajo-pagination-buttons { flex-wrap: wrap; }
  .waajo-row-actions { flex-wrap: wrap; justify-content: flex-end; }
  .waajo-row-actions .waajo-action-label-optional { display: none; }
  .waajo-row-actions .btn { padding: 0 9px; }
}

@media (max-width: 480px) {
  .waajo-stat-grid { grid-template-columns: minmax(0, 1fr); }
  .waajo-stat-card { padding: 11px; }
  .waajo-voucher-actions { width: 100%; margin-left: 0; }
  .waajo-voucher-actions .btn { width: 100%; }
}

/* ============================= REDESIGN LAYOUT ============================= */

.waajo-account-page {
  max-width: 100%;
  padding-bottom: 24px;
}

.waajo-account-heading {
  margin-bottom: 16px;
}

.waajo-account-heading-copy h3 {
  font-size: 26px;
}

.waajo-account-layout {
  display: block;
}

.waajo-account-main {
  width: 100%;
  max-width: 100%;
}

.waajo-account-main > * + * {
  margin-top: 14px;
}

.waajo-setup-strip {
  padding: 10px 12px;
  border-radius: 12px;
}

.waajo-setup-steps {
  gap: 6px;
}

.waajo-setup-step {
  padding: 6px 8px;
  border-radius: 8px;
}

.waajo-setup-step small {
  max-width: none;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}

.waajo-stat-grid {
  gap: 10px;
}

.waajo-stat-card {
  gap: 10px;
  padding: 11px 12px;
  border-radius: 12px;
}

.waajo-stat-icon {
  flex-basis: 34px;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  font-size: 15px;
}

.waajo-stat-label {
  overflow: visible;
  font-size: 11px;
  text-overflow: clip;
  white-space: normal;
}

.waajo-stat-copy strong {
  margin: 1px 0;
  font-size: 23px;
}

.waajo-stat-copy small {
  overflow: visible;
  font-size: 11px;
  text-overflow: clip;
  white-space: normal;
}

.waajo-panel-head {
  padding: 15px 16px 12px;
}

.waajo-panel-head h4 {
  font-size: 18px;
}

.waajo-numbers-head {
  align-items: center;
}

.waajo-number-tools {
  gap: 6px;
}

.waajo-number-table-wrap {
  padding: 0;
  overflow: visible !important;
}

.waajo-number-table {
  width: 100%;
  min-width: 880px;
  table-layout: fixed;
  font-size: 13px;
}

.waajo-number-table th:nth-child(1),
.waajo-number-table td:nth-child(1) {
  width: 42px;
}

.waajo-number-table th:nth-child(2),
.waajo-number-table td:nth-child(2) {
  width: 24%;
}

.waajo-number-table th:nth-child(3),
.waajo-number-table td:nth-child(3) {
  width: 24%;
}

.waajo-number-table th:nth-child(4),
.waajo-number-table td:nth-child(4) {
  width: 140px;
}

.waajo-number-table th:nth-child(5),
.waajo-number-table td:nth-child(5) {
  width: 150px;
}

.waajo-number-table th:nth-child(6),
.waajo-number-table td:nth-child(6) {
  width: 180px;
}

.waajo-number-table thead th {
  padding: 10px;
  font-size: 11px;
}

.waajo-number-table tbody td {
  padding: 11px 10px;
}

.waajo-wa-number {
  min-width: 0;
  font-size: 13px;
}

.waajo-wa-number span {
  overflow-wrap: anywhere;
}

.waajo-license-name {
  font-size: 13px;
  overflow-wrap: anywhere;
}

.waajo-muted-text {
  font-size: 11px;
}

.waajo-license-expiry span {
  font-size: 13px;
}

.waajo-license-expiry small {
  font-size: 11px;
}

.waajo-status-pill {
  padding: 4px 8px;
  font-size: 11px;
}

.waajo-row-actions {
  flex-wrap: nowrap;
  gap: 5px;
}

.waajo-row-actions .btn {
  height: 34px;
  padding: 0 8px;
  font-size: 12px;
}

.waajo-row-actions .waajo-row-detail {
  min-width: 58px;
}

.waajo-row-actions .waajo-row-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 84px;
}

.waajo-row-options .dropdown-menu {
  min-width: 230px;
}

.waajo-info-grid {
  gap: 10px;
}

.waajo-info-box {
  padding: 12px;
}

.waajo-guide {
  position: static;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.waajo-guide-card {
  padding: 14px;
  border-radius: 12px;
}

.waajo-guide-card + .waajo-guide-card {
  margin-top: 0;
}

.waajo-guide-qr {
  grid-column: auto;
}

.waajo-guide-card h4,
.waajo-guide-card h5 {
  font-size: 14px;
}

.waajo-guide-steps p,
.waajo-guide-qr ul {
  font-size: 12px;
}

.waajo-buy-card p {
  font-size: 11px;
}

.waajo-voucher-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.waajo-voucher-card + .waajo-voucher-card {
  margin-top: 0;
}

.waajo-voucher-more {
  grid-column: 1 / -1;
}

.waajo-license-cards {
  display: none;
}

@media (max-width: 1350px) {
  .waajo-guide {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1279px) {
  .waajo-number-table-wrap {
    overflow-x: auto !important;
  }
}

@media (max-width: 1199px) {
  .waajo-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .waajo-numbers-head {
    align-items: stretch;
    flex-direction: column;
  }

  .waajo-number-tools {
    justify-content: flex-start;
    width: 100%;
  }

  .waajo-search-box {
    flex: 1 1 220px;
  }

  .waajo-number-table-wrap {
    overflow-x: auto !important;
  }

  .waajo-guide {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .waajo-guide-qr {
    grid-column: 1 / -1;
  }
}

@media (max-width: 1199px) {
  .waajo-voucher-list {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 767px) {
  .waajo-account-heading-copy h3 {
    font-size: 23px;
  }

  .waajo-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .waajo-number-tools {
    align-items: stretch;
  }

  .waajo-search-box {
    flex: 1 1 100%;
    width: 100%;
  }

  .waajo-number-tools .waajo-select {
    flex: 1 1 150px;
  }

  .waajo-number-table-wrap {
    display: none;
  }

  .waajo-license-cards {
    display: block;
    padding: 0 12px 4px;
  }

  .waajo-card-loading {
    padding: 12px 0;
  }

  .waajo-license-card {
    padding: 14px;
    border: 1px solid #e7edf5;
    border-radius: 12px;
    background: #ffffff;
  }

  .waajo-license-card + .waajo-license-card {
    margin-top: 10px;
  }

  .waajo-license-card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .waajo-license-card-label {
    margin-top: 9px;
    color: #344054;
    font-size: 14px;
    font-weight: 700;
    overflow-wrap: anywhere;
  }

  .waajo-license-card-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 11px;
    padding-top: 11px;
    border-top: 1px solid #f1f4f8;
  }

  .waajo-license-card-meta span {
    display: block;
    color: #98a2b3;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .waajo-license-card-meta strong {
    display: block;
    margin-top: 2px;
    color: #344054;
    font-size: 13px;
  }

  .waajo-license-card-meta small {
    display: block;
    margin-top: 2px;
    color: #12b76a;
    font-size: 11px;
  }

  .waajo-license-card-meta small.is-expired {
    color: #d92d20;
  }

  .waajo-license-card-meta small.is-draft {
    color: #b54708;
  }

  .waajo-license-card-meta small.is-info {
    color: #2e90fa;
  }

  .waajo-license-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
  }

  .waajo-license-card-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex: 1 1 auto;
    height: 36px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
  }

  .waajo-guide {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .waajo-guide-qr {
    grid-column: auto;
  }

  .waajo-guide-card + .waajo-guide-card {
    margin-top: 0;
  }

  .waajo-pagination {
    padding: 12px;
  }

  .waajo-pagination-buttons {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .waajo-stat-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .waajo-license-card-meta {
    grid-template-columns: minmax(0, 1fr);
  }

  .waajo-license-card-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/license/accountWhatsApp.vue